import { Divider } from "primereact/divider";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import { Description } from "../../../components/Description";
import styles from "../../../components/ListDescriptions/styles.module.css";
import { formatarCPF } from "../../../utils";

export default function PessoaCadastral({
  pessoaCadastral
}: {
  pessoaCadastral: any
}) {
  const { t } = useTranslation();

  if (!pessoaCadastral || !pessoaCadastral.BasicData) {
    if (pessoaCadastral?.message) {
      return <Panel header={t('pessoa')}><p>{pessoaCadastral.message}</p></Panel>;
    }
    return null;
  }

  const basicData = pessoaCadastral.BasicData;
  let rg = null;

  // Logica extrair RG
  if (basicData.AlternativeIdNumbers && Object.getOwnPropertyNames(basicData.AlternativeIdNumbers).length > 0) {
    const rgKey = Object.getOwnPropertyNames(basicData.AlternativeIdNumbers).find(k => k.includes('RG'));
    if (rgKey) {
      rg = basicData.AlternativeIdNumbers[rgKey];
    }
  }

  if (basicData.ExtendedDocumentInformation && Object.getOwnPropertyNames(basicData.ExtendedDocumentInformation).length > 0) {
    const rgKeyExt = Object.getOwnPropertyNames(basicData.ExtendedDocumentInformation).find(k => k.includes('RG'));
    if (rgKeyExt) {
      const extInfo = basicData.ExtendedDocumentInformation[rgKeyExt];
      if (extInfo && extInfo.DocumentIssuingAgency && extInfo.DocumentIssuingStateCode) {
        const suffix = `${extInfo.DocumentIssuingAgency} - ${extInfo.DocumentIssuingStateCode}`;
        rg = rg ? `${rg} ${suffix}` : `${extInfo.DocumentNumber} ${suffix}`;
      }
    }
  }

  const formatDate = (dateString: string) => {
    if (!dateString) return 'Não Informado';
    try {
      if (dateString.length >= 10) {
        return `${dateString.substring(8, 10)}/${dateString.substring(5, 7)}/${dateString.substring(0, 4)}`;
      }
      return dateString;
    } catch (e) {
      return dateString;
    }
  };

  return (
    <Panel header={t('pessoa')}>
      <div>
        <Divider align="left">
          <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>
            <span style={{ paddingLeft: '0.5rem' }}>
              <b>Dados Pessoais</b>
            </span>
          </div>
        </Divider>

        <div className={styles.wrapper}>
          <div className={styles.gridContainer}>
            <Description label={t('documento')} value={formatarCPF(basicData.TaxIdNumber)} />
            <Description label={t('nome')} value={basicData.Name} />
            <Description label={t('rg')} value={rg || 'Não Informado'} />
            <Description label={t('dataNascimento')} value={formatDate(basicData.BirthDate)} />
            <Description label={t('idade')} value={basicData.Age} />
            <Description label={t('sexo')} value={basicData.Gender === 'M' ? 'Masculino' : basicData.Gender === 'F' ? 'Feminino' : basicData.Gender} />
            <Description label={t('signo')} value={basicData.ZodiacSign} />
            <Description label={'Signo Chinês'} value={basicData.ChineseSign} />
            <Description label={t('nacionalidade')} value={basicData.BirthCountry} />
            <Description label={t('nomeMae')} value={basicData.MotherName} />
            <Description label={t('nomePai')} value={basicData.FatherName || 'Não Informado'} />
            <Description label={'Nome Padronizado'} value={basicData.Aliases?.StandardizedName} />
            <Description label={'Nome Comum'} value={basicData.Aliases?.CommonName} />
          </div>
        </div>

        <br />
        <Divider align="left">
          <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
            <span style={{ paddingLeft: '0.5rem' }}>
              <b>Situação Cadastral</b>
            </span>
          </div>
        </Divider>

        <div className={styles.wrapper}>
          <div className={styles.gridContainer}>
            <Description label={t('statusDocumento')} value={basicData.TaxIdStatus} />
            <Description label={t('statusData')} value={formatDate(basicData.TaxIdStatusDate)} />
            <Description label={t('origem')} value={basicData.TaxIdOrigin} />
            <Description label={t('regiaoFiscal')} value={basicData.TaxIdFiscalRegion} />
            <Description label={t('dataRegistro')} value={formatDate(basicData.TaxIdStatusRegistrationDate)} />
            <Description label={t('pis')} value={basicData.AlternativeIdNumbers?.SocialSecurityNumber || 'Não Informado'} />
            <Description label={t('obito')} value={basicData.HasObitIndication ? 'Sim' : 'Não'} />
            <Description label={'Última Atualização'} value={formatDate(basicData.LastUpdateDate)} />
            <Description label={'País do Documento'} value={basicData.TaxIdCountry} />
          </div>
        </div>

        <br />
        <Divider align="left">
          <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg>
            <span style={{ paddingLeft: '0.5rem' }}>
              <b>Dados Adicionais</b>
            </span>
          </div>
        </Divider>

        <div className={styles.wrapper}>
          <div className={styles.gridContainer}>
            <Description label={'Score Unicidade Nome'} value={basicData.NameUniquenessScore} />
            <Description label={'Score Unicidade Primeiro Nome'} value={basicData.FirstNameUniquenessScore} />
            <Description label={'Score Unicidade Nome Completo'} value={basicData.FirstAndLastNameUniquenessScore} />
            <Description label={'Contagem Palavras Nome'} value={basicData.NameWordCount} />
            <Description label={'Quantidade Homônimos'} value={basicData.NumberOfFullNameNamesakes} />
            <Description label={'Data Nasc. Fonte RF'} value={formatDate(basicData.CapturedBirthDateFromRFSource)} />
            <Description label={'Data Nasc. Válida Fonte RF'} value={basicData.IsValidBirthDateInRFSource ? 'Sim' : 'Não'} />
          </div>
        </div>
      </div>
    </Panel>
  );
}